import styled from "styled-components";

const UserInfoWrapper = styled.div`
  .dot-indicator {
    width: 10px;
    height: 10px;
    border-radius: 100%;
  }
  .dot-indicator.dot-indicator-sm {
    width: 6px;
    height: 6px;
  }
`;

export default UserInfoWrapper;
